<div class="modal-body">
    <app-terms></app-terms>
</div>
